<template>
  <sect class="hero">
    <wrap class="lg">
      <div class="headline">
        <h2>
          Organize your auto service data
        </h2>
        <p>
          A cloud solution to scheduling, clients, vehicles &amp; invoices that does its job and doesn't get in your way.
        </p>
        <div class="actions">
          <btn v-if="isAuth" class="ib lg round" to="Board">
            Open Jobcarda
          </btn>
          <btn v-else class="ib lg round" to="Signup">
            Sign Up
          </btn>
        </div>
      </div>
      <div class="preview">
        <img src="/static/images/board-view.jpg"/>
      </div>
    </wrap>
  </sect>
</template>

<script>
import { getters } from 'views/utils'

export default {
  computed: getters(),
}
</script>

<style lang="scss">
@import '~style/variables';

.sect.hero {
  background-color: #fff;
  background-image: url('/static/images/round-wedge-light.svg');
  background-position: right top;
  color: $c-blue;
  padding: 6rem 0 2rem;
  position: relative;
  .headline {
    text-align: center;
    > h2 {
      // background-repeat: repeat-x;
      // background-image: linear-gradient(to left, #3e3e3e, #000);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      font-size: $h2;
      line-height: 3rem;
      text-align: inherit;
    }
    > p {
      font-size: $h4;
      font-weight: $medium;
      line-height: 2rem;
      margin: 2rem 0 3rem;
    }
    .btn.lg {
      @include trans(0.8s);
      background-image: linear-gradient(to right, $c-success-dark, $c-success-lightish);
      border: none;
      &:hover {
        background-image: linear-gradient(to right, $c-success-dark 20px, $c-success-lightish 95%);
        box-shadow: 0 0 40px $c-success;
      }
      // &.success {
      //   background-image: linear-gradient(to right, $c-success, $c-success-lightish);
      // }
    }
    @media screen and (min-width: $res-sm) {
      margin-bottom: 0;
      > h2 {
        font-size: $h1;
      }
    }
  }
  .actions {
    text-align: center;
  }
  .preview {
    text-align: center;
    img {
      border-radius: $r-lg;
      margin-top: 2rem;
      max-width: 80%;
      width: 100%;
    }
  }
  @media screen and (min-width: 1260px) {
    background-image: url('/static/images/round-wedge.svg');
    height: 80vh;
    padding: 14rem 0 2rem;
    .actions {
      text-align: left;
    }
    .headline {
      max-width: 450px;
      text-align: left;
      > h2 {
        line-height: 4.5rem;
      }
    }
    .preview {
      img {
        max-width: 920px;
        position: absolute;
        right: -10%;
        top: 20%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/landing/Hero.vue